import React from "react";
import PropTypes from 'prop-types';
import { Input } from 'antd';
import ButtonComponent from 'components/controls/Button';

const HeaderSearchBox = (props) => (
  <div className="tableSearch">
    <Input
      placeholder='Search'
      value={props.selectedKeys[0]}
      onChange={e => props.setSelectedKeys(e.target.value ? [e.target.value] : [])}
      onPressEnter={props.handleSearch(props.selectedKeys, props.confirm, props.stateName)}
      className="ent-search-filter-field"
    />
    <ButtonComponent type="button" value="Ok" className="button-global button-primary small autoHeight ent-search-filter-actions"
      onClick={props.handleSearch(props.selectedKeys, props.confirm, props.stateName)} />
    <ButtonComponent type="button" value="Reset" className="button-global button-border small autoHeight"
      onClick={props.handleReset(props.clearFilters, props.stateName)} />
  </div>
);

HeaderSearchBox.propTypes = {
  setSelectedKeys: PropTypes.func.isRequired,
  selectedKeys: PropTypes.array.isRequired,
  confirm: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  stateName: PropTypes.string.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
}

export default HeaderSearchBox;